import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPersonDolly } from "@fortawesome/pro-regular-svg-icons";
import { faArrowLeftFromLine } from "@fortawesome/pro-duotone-svg-icons";
import LabelCount from "../../../components/ui/LabelCount";
import dayjs from "dayjs";
import OrderState from "../../../components/ui/OrderState";

function ItemOrderList({ itemOrders }) {
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`grid ${
          isAdmin ? "grid-cols-3 lg:grid-cols-6" : "grid-cols-3 lg:grid-cols-4"
        } bg-bioport-blue-light text-white font-bold px-4 p-3 mt-5`}
      >
        <div className="text-center">{t("settings.orders.header.number")}</div>
        {isAdmin && <div className="hidden lg:block"></div>}
        <div className="hidden lg:block text-center">
          {t("settings.orders.header.date")}
        </div>
        {isAdmin && (
          <div className="hidden lg:block">
            {t("settings.orders.header.partner")}
          </div>
        )}
        <div className="text-center">{t("settings.orders.header.items")}</div>
        <div className="text-center">{t("settings.orders.header.state")}</div>
        <div className="text-center"></div>
      </div>
      {itemOrders.map((purchaseOrderItem, key) => (
        <>
          <div
            className={`grid ${
              isAdmin
                ? "grid-cols-3 lg:grid-cols-6"
                : "grid-cols-3 lg:grid-cols-4"
            } px-4 p-3 hover:bg-gray-50 ${key % 2 === 0 && "bg-gray-100"}`}
          >
            <div className="text-center">
              <Link
                className="hover:underline"
                to={"/settings/orders/" + purchaseOrderItem.purchaseOrder.id}
              >
                {purchaseOrderItem.purchaseOrder.pieceNumber}
              </Link>
            </div>
            <div className="hidden lg:block text-center">
              {isAdmin && (
                <FontAwesomeIcon
                  icon={
                    purchaseOrderItem.purchaseOrder.itemReceipt
                      ? faPersonDolly
                      : faArrowLeftFromLine
                  }
                  className={`ml-1 ${
                    !purchaseOrderItem.purchaseOrder.itemReceipt &&
                    "text-bioport-orange"
                  }`}
                  title={
                    purchaseOrderItem.purchaseOrder.itemReceipt
                      ? t("settings.orders.itemReceiptOn")
                      : t("settings.orders.itemReceiptOff")
                  }
                />
              )}
            </div>

            <div className="text-center">
              {dayjs(purchaseOrderItem.purchaseOrder.createdAt).format(
                "DD/MM/YYYY"
              )}
            </div>

            {isAdmin && (
              <div className="hidden lg:block">
                <Link
                  className="hover:underline"
                  to={
                    "/settings/partners/" +
                    purchaseOrderItem.purchaseOrder.partner.id
                  }
                >
                  {purchaseOrderItem.purchaseOrder.partner.name}
                </Link>
              </div>
            )}
            <div className="text-center">
              <LabelCount
                count={purchaseOrderItem.quantity}
                defaultClass="bg-gray-300"
                enabledClass="bg-bioport-blue text-white"
              />
            </div>
            <div className="text-center">
              <OrderState
                order={purchaseOrderItem.purchaseOrder}
                className="px-2 py-1 text-xs font-normal"
              />
            </div>
          </div>
        </>
      ))}
    </>
  );
}

export default ItemOrderList;
